import {
  Component,
  OnInit,
  ViewChild,
  Output,
  EventEmitter,
  Input,
} from "@angular/core";
// import { BsModalService } from "ngx-bootstrap/modal";
// import { BsModalRef } from "ngx-bootstrap/modal/bs-modal-ref.service";
import { IOption } from "ng-select";
import { NgForm, FormGroup, FormBuilder } from "@angular/forms";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { Router } from "@angular/router";
import { HelperService } from "../../services/helper.service";
import { DesignationMasterService } from "../../services/designation-master.service";
import { ObjectivesService } from "../../services/objectives.service";
import { DatePipe } from '@angular/common';
import {BsDatepickerConfig, BsModalRef, BsModalService, de} from "ngx-bootstrap";
@Component({
  selector: "app-create-objectives-modal.component",
  templateUrl: "./create-objectives-modal.component.html",
  providers: [ObjectivesService,],
})
export class CreateObjectivesModal implements OnInit {
  @Output() public objectiveReload: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild("form") form: NgForm;
  @ViewChild("swalModal") swalModal: any;
  @ViewChild("errorMessageHtml") errorMessageHtml: any;
  @Output() tableReload: EventEmitter<any> = new EventEmitter();

  public successMsg: string = "";
  public htmlErrorMessage: string = "";
  selectedCompanySystemID = this.helperService.getSelectedCompanyId();
  companySystemID = +this.helperService.getSelectedCompanyId();
  // languageSystemID = +this.helperService.getAvailableLang();
  languageSystemID = 1;

  assCategories: any;
  assElements: any;
  assCompEle: any;
  templateList: any;
  codeGenerated = "";
  dateGenerated = "";

  displayStatus = [
    { value: 0, label: "No" },
    { value: 1, label: "Yes" },
  ];

  formData: any = {
    code: "",
    date: "", 
    description: "",
    comment: "",
    active: "",
    formattedDate: "",
  };
  
  public colorTheme = "theme-blue";
  public bsConfig: Partial<BsDatepickerConfig>;

  constructor(
    private router: Router,
    public bsModalRef: BsModalRef,
    private modalService: BsModalService,
    private helperService: HelperService,
    private objectivesService: ObjectivesService,
    private fb: FormBuilder,
    private designationMasterService: DesignationMasterService,
    private datePipe: DatePipe,
  ) {
    this.bsConfig = Object.assign({}, {containerClass: this.colorTheme, dateInputFormat: "DD/MM/YYYY"});
    
     }

  showErrorHtml() {
    setTimeout(() => {
      this.errorMessageHtml.show();
    }, 0);
  }

  closeModal() {
    this.bsModalRef.hide();
    this.modalService.setDismissReason("questionbank_closed");
  }

  closeModalAfterCreate() {
    this.bsModalRef.hide();
    this.modalService.setDismissReason("questionbank_closed");
  }

  showSuccessHtml() {
    setTimeout(() => {
      this.swalModal.show();
    }, 0);
  }

  ngOnInit() {
    this.generateRandomDocNumber();
    this.getFormData();
    this.setCurrentDate();
    this.setCurrentDateNew();
  }

  generateRandomDocNumber() {
    const randomNumber = Math.floor(Math.random() * 99999) + 1;
    this.formData.code = `ASM/${randomNumber.toString().padStart(6, "0")}`;
    this.codeGenerated = this.formData.code;
  }




  setCurrentDate() {
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, '0');
    const dd = String(today.getDate()).padStart(2, '0');
    this.formData.date = `${dd}/${mm}/${yyyy}`;
    this.dateGenerated = this.formData.date;
  }


  dateGeneratedNew: string = "";

  setCurrentDateNew() {
    const today = new Date();
    const formattedDate = this.datePipe.transform(today, 'MMM dd, yyyy');
    this.dateGeneratedNew = formattedDate;
  }




  public getFormData() {
    const that = this;
    this.designationMasterService
      .getAllEmployeesFormData()
      .get({
        companyId: +that.helperService.getSelectedCompanyId()
      })
      .subscribe((data) => {
        const resp = data.data.data;
        //console.log(resp);
        that.assCategories = that.helperService.setSelect2DropDownOptions(resp.assCategories, 'auto_id', 'code');
        that.assElements = that.helperService.setSelect2DropDownOptions(resp.assElements, 'auto_id', 'description');
        that.assCompEle = that.helperService.setSelect2DropDownOptions(resp.assCompEle, 'auto_id', 'description');
        that.templateList = that.helperService.setSelect2DropDownOptions(resp.objctiveTemplate, 'auto_id', 'description');
      }, (error) => {
      });
  }






  // public getFormData() {
  //   const that = this;
  //   this.designationMasterService
  //     .getTemplateEmployeesFormData()
  //     .get({
  //       companySystemID: +that.helperService.getSelectedCompanyId(),
  //       type: "create",
  //     })
  //     .subscribe(
  //       (data) => {
  //         const resp = data.data.data;
  //         //console.log(resp);
  //         that.assCategories = that.helperService.setSelect2DropDownOptions(
  //           resp.assCategories,
  //           "auto_id",
  //           "code"
  //         );
  //         that.assElements = that.helperService.setSelect2DropDownOptions(
  //           resp.assElements,
  //           "auto_id",
  //           "description"
  //         );
  //         that.assCompEle = that.helperService.setSelect2DropDownOptions(
  //           resp.assCompEle,
  //           "auto_id",
  //           "description"
  //         );
  //         that.templateList = that.helperService.setSelect2DropDownOptions(
  //           resp.objctiveTemplateList,
  //           "auto_id",
  //           "description"
  //         );
          // //console.log(resp.objctiveTemplateList);
  //       },
  //       (error) => { }
  //     );
  // }




  createObjAssess(formData: any) {

    const formattedExpiry = this.helperService.formatDate(formData.expiry);
    const formattedDate = this.helperService.formatDate(formData.date);
    const displayValue = formData.isDisplay === undefined ? 0 : formData.isDisplay;


    const requestData = {
      code: this.codeGenerated,
      date: formData.date !== undefined ? formattedDate : this.dateGeneratedNew,
      description: formData.description,
      template_id: formData.template_id,
      expiry: formattedExpiry,
      company_id: this.companySystemID,
      is_self_marks_display: displayValue,
    };
    //console.log(requestData);
    let that = this;
    that.objectivesService
      .createObjAssess()
      .post(requestData)
      .subscribe(
        (resp: any) => {
          const autoId = resp.data.auto_id;
          //console.log(autoId);
          that.showSuccessHtml();
          this.tableReload.emit();
        },
        (error) => {
          that.htmlErrorMessage = "";
          if (error.status == 500) {
            that.htmlErrorMessage = error.data.message;
            that.showErrorHtml();
          } else if (error.status == 422) {
            that.htmlErrorMessage = that.helperService.serverSideError422(
              error.data.message
            );
            that.showErrorHtml();
            this.tableReload.emit();
          }
        }
      );
  }
}



// WEBPACK FOOTER //
// /app/src/app/competancy/create-objectives-modal/create-objectives-modal.component.ts